/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { BetKindEnumType } from './BetKindEnum'
import { RootStoreType } from './index'

/**
 * BetBase
 * auto generated base class for the model BetModel.
 */
export const BetModelBase = ModelBase.named('Bet')
  .props({
    __typename: types.optional(types.literal('Bet'), 'Bet'),
    amount: types.union(types.undefined, types.number),
    kind: types.union(types.undefined, BetKindEnumType)
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class BetModelSelector extends QueryBuilder {
  get amount() {
    return this.__attr('amount')
  }
  get kind() {
    return this.__attr('kind')
  }
}
export function selectFromBet() {
  return new BetModelSelector()
}

export const betModelPrimitives = selectFromBet().amount.kind
